export const TENANT_STATUS_LABELS = {
    active: "Ativo",
    trial: "Em Teste",
    trial_scheduled: "Trial Agendado",
    inadimplente: "Inadimplente",
    blocked: "Bloqueado",
    cancelled: "Cancelado",
    expired: "Expirado",
};

export const TENANT_STATUS_COLORS = {
    active: "success",
    trial: "accent",
    trial_scheduled: "warning",
    inadimplente: "warning",
    blocked: "danger",
    cancelled: "muted",
    expired: "danger",
};

export const STATUS_FILTER_OPTIONS = [
    { label: "Todos", value: "all" },
    { label: "Ativos", value: "active" },
    { label: "Em Teste", value: "trial" },
    { label: "Trial Agendado", value: "trial_scheduled" },
    { label: "Inadimplentes", value: "inadimplente" },
    { label: "Bloqueados", value: "blocked" },
    { label: "Cancelados", value: "cancelled" },
    { label: "Expirados", value: "expired" },
];
